import { useCallback, useState } from 'react'
import { useToast } from '@/hooks/use-toast'
import Button from '../button'
import Label from '../label'
import AuthCard from './auth-card'
import Loader from '../loader'
import { AUTH_CONFIG } from '../../auth/config'

const ForgotPassword = () => {
  const [email, setEmail] = useState('')
  const [loading, setLoading] = useState(false)
  const { toast } = useToast()

  const handleEmailChange = useCallback(
    (e) => {
      setEmail(e.target.value)
    },
    [setEmail],
  )

  const handleForgotPassword = useCallback(
    async (e) => {
      e.preventDefault()
      setLoading(true)

      try {
        const response = await fetch(`${AUTH_CONFIG.authServerUrl}/api/auth/forgot-password`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        })

        if (!response.ok) {
          const data = await response.json().catch(() => ({}))
          throw new Error(data.message || `Request failed (${response.status})`)
        }

        toast({
          title: 'Success!',
          description: 'Password reset email sent! Check your inbox.',
          variant: 'success',
        })
      } catch (err) {
        toast({
          title: 'Error!',
          description: `Error: ${err.message}`,
          variant: 'destructive',
        })
      } finally {
        setLoading(false)
      }
    },
    [email, toast],
  )

  return (
    <AuthCard title="Forgot password">
      <div className="relative max-w-md mx-auto p-4">
        {loading && <Loader />}
        <form onSubmit={handleForgotPassword}>
          <div className="mb-6">
            <p className="text-sm mb-4 text-subtle">Enter your email address for instructions.</p>
            <Label text="Email" htmlFor="email" />
            <input
              type="email"
              id="email"
              name="email"
              className="w-full px-3 py-2 bg-background border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Email"
              required
              onChange={handleEmailChange}
            />
          </div>

          <div className="text-center">
            <Button type="submit" disabled={loading ? true : false}>
              Send request
            </Button>
          </div>
        </form>
      </div>
    </AuthCard>
  )
}

export default ForgotPassword
